<template>
  <div :class="{ padding: !is_modal }">
    <div v-if="show_load_internal_notes_button">
      <div class="is-flex is-justify-content-center">
        <a @click="init()" class="button is-info">Load Internal Notes</a>
      </div>
      <div class="vertical_space"></div>
    </div>
    <div v-else>
      <div v-if="is_loading_internal_notes" class="is-flex is-align-items-center is-flex-direction-column">
        <div class="loading"></div>
        <p><b>טוען את ההיסטוריה של הערות הפנימיות...</b></p>
        <div class="vertical_space"></div>
      </div>
      <div v-else-if="paged && load_error && stats.length === 0" class="is-flex is-align-items-center is-flex-direction-column notes-load-error" dir="rtl">
        <p class="has-text-danger mb-2">{{ load_error }}</p>
        <a @click="init()" class="button is-info is-small">נסה שוב</a>
        <div class="vertical_space"></div>
      </div>
      <div v-else>
        <div>
          <div class="is-flex is-align-items-center is-justify-content-flex-end">
            <div>
              <a @click="hideAutomatedNotes()" class="button is-info">Hide Automated Notes</a>
            </div>
            <div class="horizontal_space"></div>
            <div v-if="isMinPriorityChangable">
              <a @click="showLowerPriority()" class="button is-info">Show Lower Priority</a>
            </div>
          </div>
          <div class="vertical_space"></div>
        </div>
        <div>
          <div class="history_notes">
            <div class="note" :key="stat.id" v-for="stat in stats">
              <stat-resources v-if="stat.resources && !paged" :payload="{ stat }"></stat-resources>
              <p v-if="paged && stat.resource_type == 'Offer'" class="is-size-7 has-text-grey" dir="rtl">
                <router-link v-if="stat.applicant_id" :to="{ name: 'admin-applicants', query: { show_id: stat.applicant_id } }" class="blue_text">
                  <u>{{ stat.applicant_name || ('מועמד #' + stat.applicant_id) }}</u>
                </router-link>
                <span v-else-if="stat.applicant_name">{{ stat.applicant_name }}</span>
                <span> · הצעה #{{ stat.resource_id }}</span>
              </p>
              <p dir="rtl" style="margin-bottom: 0px;">
                <b>{{ stat.owner }}</b> (<b>{{
                  time_helper.makeTimeReadable(stat.created_at)
                }}</b
                >):
              </p>
              <p v-html="$sanitize(stat.content)" class="white_space_pre_line break_word"></p>
            </div>
            <div v-if="paged" class="is-flex is-align-items-center is-flex-direction-column notes-paging" dir="rtl">
              <p v-if="stats.length === 0 && !load_error" class="has-text-grey">אין הערות פנימיות</p>
              <p v-if="counter" class="is-size-7 has-text-grey notes-counter">מוצגות {{ counter.loaded }} מתוך {{ counter.total }}</p>
              <p v-if="load_error" class="is-size-7 has-text-danger">{{ load_error }}</p>
              <a
                v-if="has_more || load_error"
                @click="loadMore()"
                :class="{ 'is-loading': is_loading_more }"
                class="button is-info is-small is-outlined mt-2 notes-load-more"
              >טען עוד</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <textarea class="new_note" v-model.lazy="new_text"></textarea>
    </div>
    <div dir="ltr" class="is-flex is-align-items-center" :class="{ modal_footer: is_modal }">
      <a
        @click="submit()"
        :class="{ 'is-loading': is_submitting, 'is-outlined': !is_modal }"
        class="button is-info"
        >Submit</a
      >
      <div class="follow_up">
        <checkbox v-model="follow_up" :checked="follow_up">Follow Up</checkbox>
      </div>
    </div>
  </div>
</template>
<script>
import TextsHelper from '@/custom/classes/texts_helper.js'
import TimeHelper from '@/custom/classes/time_helper.js'
import StatResources from '@/components/StatResources'
import Checkbox from '@/components/Checkbox'
import {
  NOTES_PER_PAGE,
  NOTES_SORT_NEWEST_FIRST,
  buildPagedParams,
  parsePagedResponse,
  mergeNotes,
  prependNote,
  hasMoreNotes,
  notesCounter,
  noteMatchesFilter
} from '@/custom/classes/internal_notes_paging.js'

const LOAD_ERROR_TEXT = 'טעינת ההערות נכשלה. יש לנסות שוב.'
export default {
  name: 'internal-notes-modal',
  props: {
    payload: {
      type: Object,
      default: () => ({})
    },
    additional_data: {
      type: Object,
      default: () => ({})
    },
    is_modal: {
      type: Boolean,
      default: true
    },
    eager_load: {
      type: Boolean,
      default: false
    },
    // Opt-in (position modal only): newest first, NOTES_PER_PAGE at a time with
    // a "טען עוד" button, light payload. Without it the component behaves
    // exactly as before (one request, full payload).
    paged: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isMinPriorityChangable () {
      return ['Applicant', 'Company'].includes(this.mergedData.resource_type)
    },
    mergedData () {
      return { ...this.payload, ...this.additional_data }
    },
    getMinPriority () {
      return this.$utils.getInternalNotesMinPriority(this.mergedData.resource_type)
    },
    counter () {
      return notesCounter(this.stats.length, this.total)
    }
  },
  data () {
    return {
      texts_helper: new TextsHelper(),
      follow_up: false,
      time_helper: new TimeHelper(),
      title: '',
      stats: [],
      new_text: '',
      show_load_internal_notes_button: true,
      is_loading_internal_notes: true,
      is_submitting: false,
      notes_min_priority: 5,
      show_automated_notes: this.additional_data.showAutomatedNotes || true,
      // paged mode only
      page: 0,
      total: null,
      has_more: false,
      is_loading_more: false,
      load_error: '',
      request_seq: 0
    }
  },
  created: function () {
    this.notes_min_priority = this.getMinPriority
    if (this.eager_load) {
      this.init()
    }
  },
  methods: {
    init () {
      if (this.paged) {
        this.loadFirstPage()
        return
      }
      this.show_load_internal_notes_button = false
      this.is_loading_internal_notes = true
      this.$network_utils.getStats({
        min_priority: this.notes_min_priority,
        resource_id: this.getResourceId(),
        resource_type: this.mergedData.resource_type,
        designator: this.show_automated_notes ? undefined : 'internal_notes',
        sort: this.mergedData.resource_type == 'Company' ? '-id' : '-created_at'
      }).then(response => {
        this.stats = response
        this.is_loading_internal_notes = false
      }).catch(() => {
        // Stop the spinner; keep whatever list was already shown (empty on a
        // first load) and say so — success rendering is untouched.
        this.is_loading_internal_notes = false
        this.$utils.emit('show_toast', { text: LOAD_ERROR_TEXT })
      })
    },
    baseStatsParams () {
      return {
        min_priority: this.notes_min_priority,
        resource_id: this.getResourceId(),
        resource_type: this.mergedData.resource_type,
        designator: this.show_automated_notes ? undefined : 'internal_notes',
        sort: NOTES_SORT_NEWEST_FIRST
      }
    },
    // Paged mode: (re)start from page 1. request_seq drops answers of requests
    // superseded by a newer reload (filter buttons, submit).
    async loadFirstPage () {
      const seq = ++this.request_seq
      this.show_load_internal_notes_button = false
      this.is_loading_internal_notes = true
      this.is_loading_more = false
      this.load_error = ''
      try {
        const params = this.baseStatsParams()
        // light=1 needs both (the server answers 400 otherwise) — never send it unscoped.
        if (!params.resource_type || params.resource_id === undefined || params.resource_id === null) {
          throw new Error('internal notes: missing resource_type/resource_id')
        }
        const response = await this.$network_utils.getStats(buildPagedParams(params, 1))
        if (seq !== this.request_seq) return
        const { items, total } = parsePagedResponse(response)
        this.stats = mergeNotes([], items)
        this.applyPage(1, items.length, this.stats.length, total)
      } catch (e) {
        if (seq !== this.request_seq) return
        this.stats = []
        this.has_more = false
        this.load_error = LOAD_ERROR_TEXT
      } finally {
        if (seq === this.request_seq) this.is_loading_internal_notes = false
      }
    },
    async loadMore () {
      if (this.is_loading_more) return
      if (this.page === 0) return this.loadFirstPage()
      const seq = this.request_seq
      const next = this.page + 1
      this.is_loading_more = true
      this.load_error = ''
      try {
        const response = await this.$network_utils.getStats(buildPagedParams(this.baseStatsParams(), next))
        if (seq !== this.request_seq) return
        const { items, total } = parsePagedResponse(response)
        const before = this.stats.length
        this.stats = mergeNotes(this.stats, items)
        this.applyPage(next, items.length, this.stats.length - before, total)
      } catch (e) {
        if (seq !== this.request_seq) return
        this.load_error = LOAD_ERROR_TEXT
      } finally {
        if (seq === this.request_seq) this.is_loading_more = false
      }
    },
    applyPage (page, pageSize, newCount, total) {
      this.page = page
      this.total = total
      this.has_more = hasMoreNotes({ lastPageSize: pageSize, newCount, per: NOTES_PER_PAGE })
    },
    // Paged mode: show the note just created at the top without reloading —
    // only if the list's current filter would return it. `posted` fills in
    // priority/designator when the create response omits them.
    afterPagedSubmit (created, posted) {
      const returned = Array.isArray(created) ? created[0] : created
      if (this.page === 0 || !returned || returned.id === undefined) {
        this.loadFirstPage()
        return
      }
      const note = { ...posted, ...returned }
      if (!noteMatchesFilter(note, this.baseStatsParams())) return
      const isNew = !this.stats.some(item => item.id === note.id)
      this.stats = prependNote(this.stats, note)
      if (isNew && this.total !== null) this.total += 1
    },
    showLowerPriority () {
      this.notes_min_priority = this.mergedData.resource_type == 'Company' ? 5 : 4
      this.init()
    },
    hideAutomatedNotes () {
      this.show_automated_notes = false
      this.init()
    },
    getResourceId () {
      return this.payload.resource_id != undefined ? this.payload.resource_id : this.payload.id
    },
    submit () {
      if (!this.follow_up && this.new_text.length == 0) {
        this.$utils.emit('show_toast', { text: 'אנא מלא/י טקסט' })
        return
      }
      let content = this.texts_helper.getBoldContent(this.new_text, 'internal_notes')
      if (content == 'problem') {
        return
      }
      this.is_submitting = true
      const posted = {
        title: 'new internal note',
        designator: this.follow_up ? 'follow_up' : 'internal_notes',
        content,
        status: 'done',
        owner: this.$utils.getOwner().name,
        priority: 7,
        resource_id: this.getResourceId(),
        resource_type: this.mergedData.resource_type
      }
      this.$network_utils
        .postStat(posted)
        .then(created => {
          if (this.paged) {
            this.afterPagedSubmit(created, posted)
          } else {
            this.init()
          }
          this.is_submitting = false
          this.new_text = ''
        })
        .catch(e => {
          if (!this.paged) throw e
          this.is_submitting = false
          this.$utils.emit('show_toast', { text: 'שמירת ההערה נכשלה. הטקסט נשמר בתיבה — יש לנסות שוב.' })
        })
    }
  },
  components: {
    StatResources,
    Checkbox
  }
}
</script>
<style scoped>
.padding{
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 10px;
}
.history_notes {
  position: relative;
  font-size: 14px;
  min-height: 330px;
  max-height: 440px;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 18px;
  margin-bottom: 30px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background-color: #f9f9f9;
}
.note {
  margin-bottom: 10px;
  border-bottom: solid 1px rgba(0, 0, 0, 0.18);
}
textarea {
  min-width: 100% !important;
}
input {
  min-width: 100% !important;
}
.follow_up {
  border-left: 1px solid rgba(0, 0, 0, 0.1);
  padding-left: 30px;
  margin-left: 30px;
}
</style>
